import upgradeData from '../../api/upgrades';
import * as types from '../mutation-types';
import Upgrade from '../../classes/upgrade';
/* eslint-disable indent */
const stateData = {
          all: []
      },
      getters   = {
          allUpgrades: s => s.all
      },
      actions   = {
          getAllUpgrades({ commit }) {
              upgradeData.getUpgrades(upgrades => {
                  commit(types.RECEIVE_UPGRADES, { upgrades });
              });
          }
      },
      mutations = {
          [types.RECEIVE_UPGRADES](state, { upgrades }) {
              if (state.all.length > 0 && !(state.all[0] instanceof Upgrade)) {
                  state.all.forEach(loaded => {
                      let match = upgrades.find(m => m.id === loaded.id);
                      if (typeof match !== 'undefined') {
                          match.merge(loaded);
                      }
                  });
              }
              state.all = upgrades;
          },
          [types.UPGRADE](state, { upgrade }) {
              state.all.find(a => a === upgrade);
          },
          [types.APPLY_UPGRADE](state, { upgrade }) {
              let u = state.all.find(a => a === upgrade);
              if (typeof u !== 'undefined') {
                u.apply();
              } else {
                  console.error('Could not apply upgrade ', upgrade);
              }
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
